import { CountryUtilType } from "UidispatcherApiModule";
const { CountryUtil }: { CountryUtil: CountryUtilType } =
    // @ts-expect-error
    await import("uidispatcher_api/UidispatcherApiModule");
export default CountryUtil;
